var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.status)+"\n  "),_c('a-icon',{attrs:{"type":_vm.iconType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }